<template>
  <div>
    <b-row>
      <b-col md="12">
        <InputSelect
          title="Save Response As"
          name="SaveResponseAs"
          isRequired
          v-model="response.content.UserInput.SaveResponseAs"
          :options="variableList"
          valueField="id"
          textField="name"
          @onDataChange="handleChangeSaveResponseAs"
          :isValidate="v.content.UserInput.SaveResponseAs.$error"
          :v="v.content.UserInput.SaveResponseAs"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <InputSelect
          title="If User Input Success Format"
          name="SuccessFormat"
          isRequired
          v-model="response.content.UserInput.SuccessFormat"
          :options="allFirstFlowList"
          valueField="mainIntentId"
          textField="intentName"
          @onDataChange="handleChangeSuccessFormat"
          :isValidate="v.content.UserInput.SuccessFormat.$error"
          :v="v.content.UserInput.SuccessFormat"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <InputSelect
          title="If User Input Wrong Format"
          name="WrongFormat"
          isRequired
          v-model="response.content.UserInput.WrongFormat"
          :options="allFirstFlowList"
          valueField="mainIntentId"
          textField="intentName"
          @onDataChange="handleChangeWrongFormat"
          :isValidate="v.content.UserInput.WrongFormat.$error"
          :v="v.content.UserInput.WrongFormat"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <InputText
          v-model="response.content.UserInput.Retry"
          textFloat="Retry"
          placeholder="Retry"
          type="text"
          name="Retry"
          isRequired
          :isValidate="v.content.UserInput.Retry.$error"
          :v="v.content.UserInput.Retry"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";

export default {
  components: {
    InputText,
    InputSelect
  },
  props: {
    response: {
      required: true,
      type: Object
    },
    v: {
      required: false,
      type: Object
    },
  },
  computed: {
    ...mapGetters({ allFirstFlowList: 'flowBuilder/getAllFirstFlowList' }),
    ...mapGetters({ variableList: 'flowBuilder/getVariableList' })
  },
  methods: {
    handleChangeSaveResponseAs(value) {
      this.response.content.UserInput.SaveResponseAs = value;
    },
    handleChangeSuccessFormat(value) {
      this.response.content.UserInput.SuccessFormat = value;
    },
    handleChangeWrongFormat(value) {
      this.response.content.UserInput.WrongFormat = value;
    },
  },
};
</script>
